"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/**
 * This class encapsulates two IIFEs that the Sushi library contains. A fake CSM and Window object are created and provided
 * to the functions so that they actually execute in a controlled environment away from any CSM code that might be executing
 * at the platform level within the page.
 *
 * The basic run order is the following:
 * 1. Build the mock CSM object, then build a mock Window object that references the CSM object as ue_csm
 * 2. Run the transportation-clients.js Script from SushiJavascriptClient providing the mocks. It will modify globals on the mock objects.
 * 3. Run the sushi-client.js script from SushiJavaScriptClient providing the mocks. It will create an instance of the sushi client and inject it into the CSM globals in the mocks.
 * 4. whenever event() is called, refer to the encapsulated csm object to add the event to the queue.
 */
var SushiClient =
/*#__PURE__*/
function () {
  (0, _createClass2.default)(SushiClient, null, [{
    key: "createSushiUrl",
    value: function createSushiUrl(region, sourceGroup) {
      if (!sourceGroup) {
        throw new Error("Sushi Driver was not provided with a source group.");
      }

      var domain;

      switch (region) {
        case SushiClient.REGIONS.NA:
          domain = "unagi-na";
          break;

        case SushiClient.REGIONS.EU:
          domain = "unagi-eu";
          break;

        case SushiClient.REGIONS.FE:
          domain = "unagi-fe";
          break;

        case SushiClient.REGIONS.CN:
          domain = "unagi-cn";
          break;

        default:
          throw new Error("Unrecognized region '".concat(region, "' provided to SushiClient."));
      }

      return "https://".concat(domain, ".amazon.com/1/events/").concat(sourceGroup);
    }
  }, {
    key: "createCsmUserContext",
    value: function createCsmUserContext(sushiUrl) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, _objectSpread2.default)({
        hiPriFlushInterval: 1000,
        lowPriFlushInterval: 10000,
        requestId: "1",
        errorChannel: "jserr",
        sessionStorageWrapper: undefined,
        errorHandlerFunction: console.log,
        sushiUrl: sushiUrl
      }, options);
    }
    /**
     * Create a Sushi Client for a region and source group
     *
     * @param region Region in SushiClient.REGIONS
     * @param sourceGroup Sushi Eel source group
     * @param errorHandler Error handler function
     * @param options Additional CSM context overrides
     * @param clientOverride An optional transportation client for overriding the default clients (navigator.sendBeacon and XDomainRequest or XMLHttpRequest)
     */

  }, {
    key: "REGIONS",
    get: function get() {
      return {
        NA: "NA",
        EU: "EU",
        FE: "FE",
        CN: "CN"
      };
    }
  }]);

  function SushiClient() {
    var region = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SushiClient.REGIONS.NA;
    var sourceGroup = arguments.length > 1 ? arguments[1] : undefined;
    var errorHandler = arguments.length > 2 ? arguments[2] : undefined;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var clientOverride = arguments.length > 4 ? arguments[4] : undefined;
    (0, _classCallCheck2.default)(this, SushiClient);
    var sushiUrl = SushiClient.createSushiUrl(region, sourceGroup);
    var csmUserContext = SushiClient.createCsmUserContext(sushiUrl, options);
    this.ue_csm = this.setupMockCSMObject(csmUserContext);
    this.encapsulatedWindow = this.setupMockWindow(this.ue_csm);
    this.transportationClientCode(this.ue_csm, window);

    if (clientOverride) {
      this.ue_csm.ue._sBcn = {
        isSupported: true,
        send: function send(endpoint, payload) {
          clientOverride(endpoint, payload);
          return true;
        }
      };
    }

    this.clientCode(this.ue_csm, this.encapsulatedWindow);
    this.errorHandler = errorHandler;
  }

  (0, _createClass2.default)(SushiClient, [{
    key: "event",
    value: function event(data, producerId, schemaId, options) {
      var debug = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (debug) {
        console.log("SushiClient wrapper publishing the following:", {
          data: data,
          producerId: producerId,
          schemaId: schemaId,
          options: options
        });
      }

      return this.ue_csm.ue.event(data, producerId, schemaId, options);
    }
    /**
     * If you plan to emit 1000 or more events per instantiated client,
     * call reset after calling event to allow the CSM client to continue sending events.
     */

  }, {
    key: "reset",
    value: function reset() {
      this.ue_csm.ue.event.reset();
    }
    /**
     * Register a callback that will be called just before each time metrics are
     * flushed to the network.
     * @param callback A function that sushi will call before flushes.
     */

  }, {
    key: "onSushiFlush",
    value: function onSushiFlush(callback) {
      this.ue_csm.ue.onSushiFlush(callback);
    }
    /**
     * Register a callback that will be called just before the page unloads.
     * This can be used to send any final metrics to sushi, such as page visit
     * duration or batched counters.
     * @param callback A function that sushi will call before unload.
     */

  }, {
    key: "onSushiUnload",
    value: function onSushiUnload(callback) {
      this.ue_csm.ue.onSushiUnload(callback);
    }
  }, {
    key: "setupMockCSMObject",
    value: function setupMockCSMObject(csmUserContext) {
      var _this = this;

      var execStub = function execStub(callback, attribution) {
        return callback;
      };

      var eventStub = function eventStub(log, producer, eventType) {
        console.warn("SushiClient CSM stub called in unsupported manner: event()");
      };

      var errorHandler = function errorHandler(logEvent, channel) {
        if (_this.errorHandler) {
          _this.errorHandler(logEvent);
        } else {
          console.log("An error has occurred in SushiClient channel " + channel, logEvent);
        }
      };

      var attachHandler = function attachHandler(evt, handler, container) {
        //TODO might be able to just use window.ue.attach?
        container = container || window; //ok to use real window global here.

        if (window.EventTarget && window.EventTarget.prototype && window.EventTarget.prototype.addEventListener) {
          window.EventTarget.prototype.addEventListener.call(container, evt, handler, !!window.ue_clf);
        } else if (container.addEventListener) {
          container.addEventListener(evt, handler, !!window.ue_clf);
        } else if (container.attachEvent) {
          container.attachEvent("on" + evt, handler);
        }
      };

      return {
        ue_hpsi: csmUserContext.hiPriFlushInterval,
        ue_lpsi: csmUserContext.lowPriFlushInterval,
        ue: {
          ssw: csmUserContext.sessionStorageWrapper,
          log: errorHandler,
          exec: execStub,
          event: eventStub,
          attach: attachHandler
        },
        ueLogError: csmUserContext.errorHandlerFunction,
        ue_surl: csmUserContext.sushiUrl,
        ue_id: csmUserContext.requestId,
        ue_err_chan: csmUserContext.errorChannel
      };
    }
  }, {
    key: "setupMockWindow",
    value: function setupMockWindow(ue_csm) {
      //apparently cannot ref the setTimeout function directly in some browsers so we have to wrap it.
      var timeoutWrapper = function timeoutWrapper(fn, timeout) {
        return window.setTimeout(fn, timeout);
      };

      return {
        ue_csm: ue_csm,
        ueLogError: ue_csm.ueLogError,
        ue: ue_csm.ue,
        setTimeout: timeoutWrapper
      };
    }
    /**
     * Code within function pulled directly from
     * https://code.amazon.com/packages/SushiJavaScriptClient/blobs/mainline/--/javascript/sushi-client.js
     */

  }, {
    key: "clientCode",
    value: function clientCode(ue_csm, window) {
      ue_csm.ue.exec(function (c, f) {
        function C() {
          for (var a = 0; a < arguments.length; a++) {
            var b = arguments[a];

            try {
              var c;

              if (b.isSupported) {
                var g = t.buildPayload(k, e);
                c = b.send(N, g);
              } else throw dummyException;

              return c;
            } catch (m) {}
          }

          D({
            m: "All supported clients failed",
            attribution: "CSMSushiClient_TRANSPORTATION_FAIL",
            f: "sushi-client.js",
            logLevel: "ERROR"
          }, f.ue_err_chan || "jserr");
        }

        function n() {
          if (e.length) {
            for (var a = 0; a < p.length; a++) {
              p[a]();
            }

            C(d._sBcn || {}, d._ajx || {});
            e = [];
            h = {};
            k = {};
            u = v = q = w = 0;
          }
        }

        function O() {
          var a = new Date(),
              b = function b(a) {
            return 10 > a ? "0" + a : a;
          };

          return Date.prototype.toISOString ? a.toISOString() : a.getUTCFullYear() + "-" + b(a.getUTCMonth() + 1) + "-" + b(a.getUTCDate()) + "T" + b(a.getUTCHours()) + ":" + b(a.getUTCMinutes()) + ":" + b(a.getUTCSeconds()) + "." + String((a.getUTCMilliseconds() / 1E3).toFixed(3)).slice(2, 5) + "Z";
        }

        function x(a) {
          try {
            return JSON.stringify(a);
          } catch (b) {}

          return null;
        }

        function E(a, b, l, g) {
          var m = !1;
          g = g || {};
          r++;
          r == F && D({
            m: "Max number of Sushi Logs exceeded",
            f: "sushi-client.js",
            logLevel: "ERROR",
            attribution: "CSMSushiClient_MAX_CALLS"
          }, f.ue_err_chan || "jserr");
          var y;
          if (y = !(r >= F)) (y = a && -1 < a.constructor.toString().indexOf("Object") && b && -1 < b.constructor.toString().indexOf("String") && l && -1 < l.constructor.toString().indexOf("String")) || P++;
          y && (d.count && d.count("Event:" + l, 1), a.producerId = a.producerId || b, a.schemaId = a.schemaId || l, a.timestamp = O(), b = Date.now ? Date.now() : +new Date(), l = Math.random().toString().substring(2, 12), a.messageId = c.ue_id + "-" + b + "-" + l, g && !g.ssd && (a.sessionId = a.sessionId || c.ue_sid, a.requestId = a.requestId || c.ue_id, a.obfuscatedMarketplaceId = a.obfuscatedMarketplaceId || c.ue_mid), (b = x(a)) ? (b = b.length, (e.length == Q || q + b > R) && n(), q += b, a = {
            data: t.compressEvent(a)
          }, e.push(a), (g || {}).n ? 0 === G ? n() : u || (u = f.setTimeout(n, G)) : v || (v = f.setTimeout(n, S)), m = !0) : m = !1);
          !m && c.ue_int && console.error("Invalid JS Nexus API call");
          return m;
        }

        function H() {
          if (!I) {
            for (var a = 0; a < z.length; a++) {
              z[a]();
            }

            for (a = 0; a < p.length; a++) {
              p[a]();
            }

            e.length && (c.ue_sbuimp && c.ue && c.ue.ssw && (a = x({
              dct: k,
              evt: e
            }), c.ue.ssw("eeldata", a), c.ue.ssw("eelsts", "unk")), C(d._sBcn || {}));
            I = !0;
          }
        }

        function J(a) {
          z.push(a);
        }

        function K(a) {
          p.push(a);
        }

        var F = 1E3,
            Q = 499,
            R = 524288,
            s = function s() {},
            d = c.ue || {},
            D = d.log || s,
            T = c.uex || s;

        (c.uet || s)("bb", "ue_sushi_v1", {
          wb: 1
        });

        var N = c.ue_surl || "https://unagi-na.amazon.com/1/events/com.amazon.csm.nexusclient.gamma",
            U = ["messageId", "timestamp"],
            A = "#",
            e = [],
            h = {},
            k = {},
            q = 0,
            w = 0,
            P = 0,
            r = 0,
            B = 0,
            L = 1,
            M = 2,
            z = [],
            p = [],
            I = !1,
            u,
            v,
            G = void 0 === c.ue_hpsi ? 1E3 : c.ue_hpsi,
            S = void 0 === c.ue_lpsi ? 1E4 : c.ue_lpsi,
            t = function () {
          function a(a) {
            h[a] = A + w++;
            k[h[a]] = a;
            return h[a];
          }

          function b(a) {
            return a.length > (A + w).length || a.charAt(0) === A;
          }

          function c(a) {
            if (a) switch ((0, _typeof2.default)(a)) {
              case "number":
                return !(isNaN(a) || Infinity === a) && b(a.toString());

              case "boolean":
                break;

              case "string":
                return b(a);

              default:
                return !0;
            }
            return !1;
          }

          function g(b) {
            if (c(b)) {
              var d = B;
              b instanceof Array ? d = M : b instanceof Function ? d = B : b instanceof Object && (d = L);

              switch (d) {
                case B:
                  b = h[b] ? h[b] : a(b);
                  break;

                case M:
                  var e = b;
                  b = [];

                  for (var d = e.length, f = 0; f < d; f++) {
                    b[f] = g(e[f]);
                  }

                  break;

                case L:
                  d = {};

                  for (e in b) {
                    b.hasOwnProperty(e) && (d[h[e] ? h[e] : a(e)] = -1 == U.indexOf(e) ? g(b[e]) : b[e]);
                  }

                  b = d;
              }
            }

            return b;
          }

          return {
            compressEvent: g,
            buildPayload: function buildPayload() {
              return x({
                cs: {
                  dct: k
                },
                events: e
              });
            }
          };
        }();

        (function () {
          if (d.event && d.event.isStub) {
            if (c.ue_sbuimp && c.ue && c.ue.ssw) {
              var a = c.ue.ssw("eelsts").val;

              if (a && "unk" === a && (a = c.ue.ssw("eeldata").val)) {
                var b;

                a: {
                  try {
                    b = JSON.parse(a);
                    break a;
                  } catch (f) {}

                  b = null;
                }

                b && b.evt instanceof Array && b.dct instanceof Object && (e = b.evt, k = b.dct, e && k && (n(), c.ue.ssw("eeldata", "{}"), c.ue.ssw("eelsts", "scs")));
              }
            }

            d.event.replay(function (a) {
              a[3] = a[3] || {};
              a[3].n = 1;
              E.apply(this, a);
            });
            d.onSushiUnload.replay(function (a) {
              J(a[0]);
            });
            d.onSushiFlush.replay(function (a) {
              K(a[0]);
            });
          }
        })();

        d.attach("beforeunload", H);
        d.attach("pagehide", H);
        d._cmps = t;
        d.event = E;

        d.event.reset = function () {
          r = 0;
        };

        d.onSushiUnload = J;
        d.onSushiFlush = K;

        try {
          f.P && f.P.register && f.P.register("sushi-client", s);
        } catch (V) {
          c.ueLogError(V, {
            logLevel: "WARN"
          });
        }

        T("ld", "ue_sushi_v1", {
          wb: 1
        });
      }, "Nxs-JS-Client")(ue_csm, window);
    }
    /**
     * The code in this function is pulled directly from:
     * https://code.amazon.com/packages/SushiJavaScriptClient/blobs/mainline/--/javascript/transportation-clients.js
     */

  }, {
    key: "transportationClientCode",
    value: function transportationClientCode(ue_csm, window) {
      ue_csm.ue.exec(function (b, c) {
        var e = function e() {},
            f = function () {
          return {
            send: function send(b, d) {
              if (d && b) {
                var a;
                if (c.XDomainRequest) a = new XDomainRequest(), a.onerror = e, a.ontimeout = e, a.onprogress = e, a.onload = e, a.timeout = 0;else if (c.XMLHttpRequest) {
                  if (a = new XMLHttpRequest(), !("withCredentials" in a)) throw "";
                } else a = void 0;
                if (!a) throw "";
                a.open("POST", b, !0);
                a.setRequestHeader && a.setRequestHeader("Content-type", "text/plain");
                a.send(d);
              }
            },
            isSupported: !0
          };
        }(),
            g = function () {
          return {
            send: function send(c, d) {
              if (c && d) if (navigator.sendBeacon(c, d)) b.ue_sbuimp && b.ue && b.ue.ssw && b.ue.ssw("eelsts", "scs");else throw "";
            },
            isSupported: !!navigator.sendBeacon && !(c.cordova && c.cordova.platformId && "ios" == c.cordova.platformId)
          };
        }();

        b.ue._ajx = f;
        b.ue._sBcn = g;
      }, "Transportation-clients")(ue_csm, window);
    }
  }]);
  return SushiClient;
}();

exports.default = SushiClient;